import router from '@/router'
import { reactive } from 'vue'
import { ElMessage } from 'element-plus'
import Cookies from 'js-cookie'
import { getUserInfo as fetchUserInfo } from '@/api'

const TOKEN_KEY = 'polydub_admin_token'
const USER_INFO_KEY = 'polydub_admin_user_info'

const PORTAL_PATH = '/home'
const DOCS_PATH = '/documentation'

const SIGNIN_PATH = '/signin'
const SIGNIN_CODE = 'signin'

const LOGIN_PATH = '/login_2025'
const LOGIN_CODE = 'login_2025'

const REGISTER_PATH = '/register'
const REGISTER_CODE = 'register'

const FORGOT_PASSWORD_PATH = '/forgot-password'
const FORGOT_PASSWORD_CODE = 'forgot-password'

const RESET_PASSWORD_PATH = '/reset-password'
const RESET_PASSWORD_CODE = 'reset-password'

const CLIENT_LAYOUT_PATH = '/clientLayout'
const CLIENT_LAYOUT_CODE = 'clientLayout'

const CLIENT_SUBSCRIPTION_PATH = '/clientLayout/subscription'



const IGNORE_MENU_CODES = [
  '403',
  '404',
  'signin',
  'login',
  REGISTER_CODE,
  LOGIN_CODE,
  FORGOT_PASSWORD_CODE,
  RESET_PASSWORD_CODE
]

const state = reactive({
  token: Cookies.get(TOKEN_KEY),
  userInfo: safeGetItem(USER_INFO_KEY) || null
})

function safeGetItem (key) {
  try {
    const item = localStorage.getItem(key)
    return item ? JSON.parse(item) : null
  } catch (e) {
    console.error(`解析${key}失败:`, e)
    localStorage.removeItem(key) // 移除无效数据
    return null
  }
}

export function getToken () {
  return state.token
}

export function setToken (token) {
  if (!token) {
    return
  }
  state.token = token
  Cookies.set(TOKEN_KEY, token)
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken () {
  state.token = undefined
  Cookies.remove(TOKEN_KEY)
  localStorage.removeItem(TOKEN_KEY)
}

export function getUserInfo () {
  return state.userInfo
}

export function setUserInfo (userInfo) {
  state.userInfo = userInfo

  if (userInfo) {
    try {
      localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo))
    } catch (e) {
      console.error('保存用户信息失败:', e)
    }
  } else {
    localStorage.removeItem(USER_INFO_KEY)
  }
}


export function isAuthenticated () {
  const token = getToken()
  const userInfo = getUserInfo()
  return !!(token && userInfo && userInfo.id)
}


export async function logout (options = { showMessage: true, redirect: true }) {
  removeToken()
  setUserInfo(null)
  if (options.showMessage) {
    ElMessage.success('退出登录成功')
  }

  if (options.redirect) {
    await router.push(LOGIN_PATH)
  }
}

export async function clientLogout (options = { showMessage: true, redirect: true }) {
  removeToken()
  setUserInfo(null)
  if (options.showMessage) {
    ElMessage.success('退出登录成功')
  }

  if (options.redirect) {
    await router.push(SIGNIN_PATH)
  }
}

export async function handleLoginSuccess (token) {
  setToken(token)
  try {
    const resp = await fetchUserInfo()
    setUserInfo(resp.data)
  } catch (e) {
    return
  }
  ElMessage.success('登录成功')
}

export { IGNORE_MENU_CODES, PORTAL_PATH, DOCS_PATH, SIGNIN_PATH, SIGNIN_CODE, LOGIN_PATH, LOGIN_CODE, REGISTER_PATH, REGISTER_CODE, FORGOT_PASSWORD_PATH, FORGOT_PASSWORD_CODE, RESET_PASSWORD_PATH, RESET_PASSWORD_CODE, CLIENT_LAYOUT_PATH, CLIENT_LAYOUT_CODE, CLIENT_SUBSCRIPTION_PATH }
